import { render, staticRenderFns } from "./HelpPopup.vue?vue&type=template&id=b6486b9c&scoped=true&"
import script from "./HelpPopup.vue?vue&type=script&lang=ts&"
export * from "./HelpPopup.vue?vue&type=script&lang=ts&"
import style0 from "./HelpPopup.vue?vue&type=style&index=0&id=b6486b9c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6486b9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardActions,VCardText,VCardTitle,VIcon,VSpacer})
